export const getLinkTargetValue = (targetValue) => {
    if (!targetValue) {
        return '_self';
    } else if (targetValue === true) {
        return '_blank';
    } else {
        return targetValue;
    }
};
